var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#D2D2D9",
    strokeWidth: 2.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.309 106.435h31.308M0 68.87h68.879M50.094 87.653v9.391c0 5.187-4.205 9.391-9.393 9.391M125.234 56.348V6.261A6.261 6.261 0 0 0 118.973 0H6.262A6.261 6.261 0 0 0 0 6.26v75.132a6.261 6.261 0 0 0 6.262 6.26h50.093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.66 68.682 2.655 8.715a5.955 5.955 0 0 0 7.038 4.089l8.842-2.048a8.034 8.034 0 0 1 7.645 13.311l-6.186 6.668a6.01 6.01 0 0 0 0 8.14l6.186 6.667a8.026 8.026 0 0 1-7.645 13.304l-8.842-2.047a5.961 5.961 0 0 0-7.007 4.12l-2.655 8.715a7.984 7.984 0 0 1-15.29 0l-2.687-8.715a5.961 5.961 0 0 0-7.038-4.089l-8.842 2.048a8.028 8.028 0 0 1-7.645-13.305l6.186-6.668a6.01 6.01 0 0 0 0-8.139L74.19 92.78a8.032 8.032 0 0 1 7.645-13.31l8.842 2.047a5.955 5.955 0 0 0 7.038-4.088l2.655-8.716a7.984 7.984 0 0 1 15.291-.03z",
    fill: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 108.015,
    cy: 103.499,
    rx: 8.998,
    ry: 8.997
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorSettings);
export default __webpack_public_path__ + "static/media/monitor-settings.6de886b212430c499f57fc37f6272d1f.svg";
export { ForwardRef as ReactComponent };